var n=function(n,r){return function(t){return n(r(t))}};export{n as default};
//# sourceMappingURL=_overArg.js.map
